var _path, _path2, _g, _path3, _g2, _path4, _g3, _path5, _g4, _path6, _g5, _path7, _g6, _path8, _g7, _path9, _g8, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBranding7Logo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 184,
    height: 31,
    viewBox: "0 0 184 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.4414 1.26453V29.867",
    stroke: "#AEAEAE",
    strokeWidth: 0.930146,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1956_36410",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 25,
    width: 29,
    height: 5
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.3581 27.4821V27.7705H10.07V28.7355H8.34701V29.9889H11.3308V26.5208H8.37289L8.3581 27.4821ZM23.4728 29.9889H26.8447V25.6667H25.5913V28.717H23.861V26.7094H21.0399V28.717H17.4535V27.948H18.9842V26.7094H16.1742V28.717H13.1794V25.6667H11.926V30H23.4728V29.9889ZM27.4659 25.7666V29.9889H28.7192V25.6667H27.4659V25.7666ZM22.0604 27.6152H22.8886V28.4286H22.0715L22.0604 27.6152ZM0.00585938 29.9667H7.77023V26.5171H6.52424V28.6986H1.25925V26.5171H0.00585938V29.9667Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1956_36410)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.7155 25.6556H0.00585938V29.9889H28.7155V25.6556Z",
    fill: "url(#paint0_linear_1956_36410)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1956_36410",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 26,
    width: 2,
    height: 2
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.51714 26.5283H3.26367V27.7559H4.51714V26.5283Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1956_36410)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.51714 26.5283H3.26367V27.7559H4.51714V26.5283Z",
    fill: "url(#paint1_linear_1956_36410)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_1956_36410",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 1,
    width: 4,
    height: 3
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4191 1.27185H15.7051V3.98585H18.4191V1.27185Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_1956_36410)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.4191 1.27185H15.7051V3.98586H18.4191V1.27185Z",
    fill: "url(#paint2_linear_1956_36410)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_1956_36410",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 1,
    width: 4,
    height: 3
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1515 1.27185H10.4375V3.98585H13.1515V1.27185Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_1956_36410)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.1515 1.27185H10.4375V3.98586H13.1515V1.27185Z",
    fill: "url(#paint3_linear_1956_36410)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_1956_36410",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 1,
    width: 29,
    height: 24
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5177 19.5738H12.9998V22.0658H15.5177V19.5738ZM26.0846 4.04503H23.5667V11.7761H26.0846V4.04503ZM5.27238 11.8094V11.0404V9.25086H2.71383V11.8094H5.27238ZM20.8529 1.45691V1.3386H28.8021V24.7796H0V1.26465H7.94184V3.97478H2.71383V6.54072H7.98252V10.3453V14.501V14.5195H2.71383V22.0621H10.2896V16.8636H18.2278V22.0658H26.0846V14.4752H20.8529V1.45691Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_1956_36410)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.7947 1H0V24.515H28.7947V1Z",
    fill: "url(#paint4_linear_1956_36410)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_1956_36410",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 4,
    width: 13,
    height: 12
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4002 4.86584L20.1129 10.5786L15.6463 15.1746L18.5748 11.3587L15.3505 14.8271L17.0551 10.4122L14.9401 14.6459L15.3283 9.9278L14.4927 14.5867L13.5387 9.94998L14.049 14.657L11.823 10.4787L13.6422 14.8492L10.3292 11.466L13.3057 15.1487L8.6875 10.5786L14.4002 4.86584Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_1956_36410)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.1166 4.86584H8.6875V15.1746H20.1166V4.86584Z",
    fill: "url(#paint5_linear_1956_36410)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_1956_36410",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 40,
    y: 0,
    width: 143,
    height: 21
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M50.434 9.63153V9.90142H57.0485V13.4656H50.3933V16.1684H59.6884V7.37616H50.4451L50.434 9.63153ZM77.6833 9.90882H81.3029V13.4435H77.7018L77.6833 9.90882ZM82.7079 16.1573H87.8842V12.9406V0H85.2776V13.4656H83.9428V8.25982V7.4612H75.1469V7.54254V13.4583H68.0333V9.90512H73.8122V7.33918H65.068V13.4656H63.6852V0.00740186H61.0971V16.1573H82.7264H82.7079ZM89.2448 0.354951V16.1684H91.8329V0.0184934H89.2448V0.354951ZM98.355 9.90882H101.956V13.4435H98.355V9.90882ZM103.161 16.1573H104.374V7.43162H95.9443V7.51296V16.1573H103.15H103.161ZM108.123 9.90882H111.721V13.4435H108.123V9.90882ZM117.699 9.90882H121.297V13.4435H117.699V9.90882ZM136.733 9.90882V13.4656H127.542V9.91253H136.729L136.733 9.90882ZM124.82 6.13386V13.4656H123.482V7.45011H115.422V7.53145V13.4472H114.117V7.45011H105.705V7.53145V16.1573H111.639V20.8936H114.139V16.1573H139.414V12.4895V7.38355H138.859H127.553V6.12277H124.82V6.13386ZM118.232 5.87135H120.676V3.48288H118.232V5.87135ZM101.202 5.87135H103.646V3.48288H101.202V5.87135ZM96.6653 5.87135H99.1092V3.48288H96.6653V5.87135ZM43.4942 5.87135H45.9381V3.48288H43.4942V5.87135ZM170.682 16.1573H182.961V13.4435V7.40204H180.228V13.4435H178.868V7.40204H176.135V13.4435H174.779V7.40204H172.035V13.4435H170.675V7.40204H167.942V20.8936H170.675L170.682 16.1573ZM145.832 9.90882H149.433V13.4435H145.832V9.90882ZM150.639 16.1573H166.585V8.57409H156.233V7.40204H153.501V11.2842H163.853V13.4435H151.84V7.43162H143.418V7.51296V16.1573H150.628H150.639ZM148.683 5.87135H151.127V3.48288H148.683V5.87135ZM144.146 5.87135H146.59V3.48288H144.146V5.87135ZM176.28 5.87135H178.724V3.48288H176.28V5.87135ZM172.19 5.87135H174.634V3.48288H172.19V5.87135ZM180.373 5.87135H182.817V3.48288H180.373V5.87135ZM40.3366 16.1647H49.0438V7.38725H46.4557V13.388H42.9026V7.38725H40.3145L40.3366 16.1647Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_1956_36410)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M182.951 0.00744629H40.3379V20.8936H182.951V0.00744629Z",
    fill: "url(#paint6_linear_1956_36410)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_1956_36410",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 40,
    y: 23,
    width: 144,
    height: 7
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M183.229 23.4853L181.099 27.6042V29.6377H179.62V27.6042L177.468 23.4853H179.169L180.363 26.0735L181.547 23.4853H183.229ZM176.866 29.6377H175.365L172.858 25.8442V29.6377H171.36V23.4853H172.858L175.365 27.2973V23.4853H176.866V29.6377ZM168.343 27.3934L167.582 25.1417L166.842 27.3934H168.343ZM168.713 28.5507H166.417L166.047 29.6377H164.491L166.709 23.4853H168.447L170.665 29.6377H169.079L168.713 28.5507ZM161.725 26.2362C161.956 26.255 162.186 26.1834 162.365 26.0365C162.438 25.9619 162.495 25.8726 162.531 25.7744C162.568 25.6763 162.583 25.5715 162.576 25.4671C162.583 25.3627 162.568 25.2579 162.531 25.1598C162.495 25.0616 162.438 24.9723 162.365 24.8977C162.187 24.7481 161.957 24.675 161.725 24.6944H160.912V26.2362H161.725ZM164.103 25.4671C164.107 25.8085 164.021 26.145 163.855 26.4432C163.683 26.7478 163.426 26.9958 163.115 27.1568C162.723 27.3504 162.289 27.4444 161.851 27.4304H160.923V29.6488H159.425V23.4853H161.855C162.284 23.473 162.71 23.559 163.101 23.7368C163.418 23.8903 163.684 24.1348 163.862 24.4393C164.038 24.753 164.127 25.1077 164.121 25.4671H164.103ZM158.335 23.4853V29.6377H156.834V25.9404L155.458 29.6377H154.249L152.863 25.9404V29.6377H151.362V23.4853H153.133L154.878 27.7447L156.586 23.4853H158.335ZM147.383 28.3325C147.604 28.3421 147.824 28.3031 148.028 28.2181C148.232 28.1331 148.414 28.0043 148.563 27.8408C148.845 27.4685 148.998 27.014 148.998 26.5467C148.998 26.0794 148.845 25.6249 148.563 25.2527C148.413 25.0909 148.23 24.9638 148.027 24.8801C147.823 24.7964 147.603 24.7583 147.383 24.7683C147.162 24.7577 146.941 24.7952 146.735 24.8781C146.53 24.9611 146.345 25.0876 146.193 25.249C145.908 25.6236 145.753 26.0814 145.753 26.5523C145.753 27.0231 145.908 27.4809 146.193 27.8556C146.346 28.0186 146.534 28.1459 146.742 28.2283C146.951 28.3107 147.175 28.3463 147.398 28.3325H147.383ZM147.383 29.7005C146.826 29.7068 146.277 29.5679 145.79 29.2975C145.312 29.033 144.916 28.6431 144.644 28.1698C144.356 27.6765 144.209 27.1139 144.218 26.543C144.209 25.9744 144.356 25.4142 144.644 24.9236C144.919 24.4576 145.315 24.0745 145.79 23.8144C146.278 23.5484 146.825 23.409 147.382 23.409C147.938 23.409 148.485 23.5484 148.973 23.8144C149.447 24.0733 149.841 24.4569 150.112 24.9236C150.396 25.4155 150.54 25.9753 150.53 26.543C150.538 27.1134 150.393 27.6755 150.108 28.1698C149.839 28.6427 149.445 29.0327 148.969 29.2975C148.489 29.5653 147.948 29.7042 147.398 29.7005H147.383ZM137.537 26.5541C137.527 25.9873 137.662 25.4273 137.929 24.9273C138.188 24.461 138.572 24.0767 139.038 23.8181C139.528 23.5471 140.08 23.4094 140.639 23.4188C141.311 23.4003 141.969 23.603 142.514 23.9956C143.036 24.3835 143.405 24.9423 143.557 25.5743H141.937C141.823 25.3324 141.642 25.1284 141.416 24.9865C141.183 24.851 140.917 24.782 140.647 24.7868C140.438 24.7806 140.23 24.8205 140.039 24.9035C139.847 24.9866 139.676 25.1109 139.538 25.2675C139.255 25.6395 139.101 26.0941 139.101 26.5615C139.101 27.029 139.255 27.4836 139.538 27.8556C139.676 28.0127 139.847 28.1375 140.038 28.2212C140.23 28.3049 140.438 28.3454 140.647 28.3399C140.917 28.3437 141.183 28.2733 141.416 28.1366C141.644 27.9965 141.825 27.7919 141.937 27.5487H143.582C143.432 28.1806 143.063 28.7387 142.54 29.1238C141.994 29.5136 141.336 29.7148 140.665 29.6968C140.106 29.7062 139.554 29.5685 139.064 29.2975C138.599 29.0383 138.214 28.6542 137.955 28.1883C137.681 27.6879 137.542 27.1246 137.552 26.5541H137.537ZM134.846 29.6377H133.359L130.845 25.8442V29.6377H129.366V23.4853H130.845L133.352 27.2973V23.4853H134.853L134.846 29.6377ZM126.094 24.687V25.9293H128.102V27.0865H126.094V28.4398H128.364V29.6377H124.612V23.4853H128.379V24.687H126.094ZM120.43 28.3399C120.67 28.3555 120.911 28.3227 121.139 28.2433C121.366 28.1639 121.575 28.0396 121.754 27.8778C121.918 27.7025 122.045 27.4952 122.127 27.2688C122.208 27.0424 122.242 26.8016 122.227 26.5615C122.251 26.3196 122.221 26.0752 122.139 25.8462C122.058 25.6172 121.926 25.4092 121.754 25.2373C121.582 25.0653 121.374 24.9337 121.145 24.852C120.916 24.7703 120.672 24.7404 120.43 24.7646H119.753V28.3399H120.43ZM120.526 23.4853C121.115 23.4657 121.699 23.5927 122.227 23.8551C122.693 24.1022 123.078 24.4783 123.336 24.9384C123.598 25.4333 123.735 25.9848 123.735 26.5449C123.735 27.1049 123.598 27.6565 123.336 28.1514C123.072 28.6153 122.679 28.9929 122.205 29.2384C121.678 29.4995 121.095 29.6265 120.508 29.6081H118.237V23.4853H120.526ZM115.206 27.3934L114.444 25.1417L113.704 27.3934H115.206ZM115.575 28.5507H113.279L112.91 29.6377H111.342L113.56 23.4853H115.298L117.516 29.6377H115.93L115.575 28.5507ZM108.728 27.3934L107.966 25.1417L107.227 27.3934H108.728ZM109.116 28.5507H106.816L106.447 29.6377H104.875L107.094 23.4853H108.828L111.046 29.6377H109.512L109.116 28.5507ZM104.225 23.4853V29.6377H102.746V25.9404L101.37 29.6377H100.157L98.771 25.9404V29.6377H97.2736V23.4853H99.0483L100.775 27.7447L102.483 23.4853H104.225ZM95.9388 25.9404V27.1827H92.0899V25.9404H95.9388ZM89.487 28.4804H91.4503V29.6377H87.9859V23.4853H89.487V28.4804ZM84.9985 27.3934L84.2368 25.1417L83.4973 27.3934H84.9985ZM85.3682 28.5507H83.0685L82.6987 29.6377H81.1274L83.3458 23.4853H85.0798L87.2982 29.6377H85.7379L85.3682 28.5507ZM76.661 27.3934L75.8993 25.1417L75.1599 27.3934H76.661ZM77.0307 28.5507H74.7347L74.365 29.6377H72.7973L75.0157 23.4853H76.7534L78.9718 29.6377H77.3857L77.0307 28.5507ZM72.4461 23.4853L70.8414 29.6377H69.026L68.0462 25.5891L67.0295 29.6377H65.2141L63.6538 23.4853H65.2585L66.1421 27.9628L67.2513 23.4853H68.9003L69.9541 27.9628L70.8488 23.4853H72.4461ZM59.9972 28.3325C60.2178 28.3421 60.4379 28.3031 60.6417 28.2181C60.8455 28.1331 61.0282 28.0043 61.1766 27.8408C61.4591 27.4685 61.612 27.014 61.612 26.5467C61.612 26.0794 61.4591 25.6249 61.1766 25.2527C61.0272 25.0909 60.8442 24.9638 60.6404 24.8801C60.4367 24.7964 60.2172 24.7583 59.9972 24.7683C59.7758 24.7577 59.5547 24.7952 59.3492 24.8781C59.1437 24.9611 58.9586 25.0876 58.8066 25.249C58.5215 25.6236 58.3671 26.0814 58.3671 26.5523C58.3671 27.0231 58.5215 27.4809 58.8066 27.8556C58.9603 28.0186 59.1479 28.1459 59.3562 28.2283C59.5645 28.3107 59.7884 28.3463 60.012 28.3325H59.9972ZM59.9972 29.7005C59.44 29.7068 58.8908 29.5679 58.4036 29.2975C57.926 29.033 57.5297 28.6431 57.2575 28.1698C56.9701 27.6765 56.823 27.1139 56.8323 26.543C56.8267 25.9746 56.9777 25.4157 57.2686 24.9273C57.544 24.4613 57.94 24.0782 58.4147 23.8181C58.9031 23.5521 59.4503 23.4127 60.0064 23.4127C60.5625 23.4127 61.1098 23.5521 61.5981 23.8181C62.0718 24.077 62.4656 24.4606 62.7369 24.9273C63.0206 25.4192 63.165 25.979 63.1547 26.5467C63.1634 27.1171 63.0177 27.6792 62.7332 28.1735C62.4637 28.6464 62.0699 29.0364 61.5944 29.3012C61.1106 29.5696 60.5652 29.7072 60.012 29.7005H59.9972ZM56.2999 23.4853V24.687H53.7931V25.9847H55.6676V27.1457H53.7931V29.634H52.292V23.4853H56.2999ZM49.2749 27.3934L48.5096 25.1417L47.7701 27.3934H49.2749ZM49.6447 28.5507H47.3486L46.9789 29.6377H45.4371L47.6555 23.4853H49.3896L51.608 29.6377H50.0218L49.6447 28.5507ZM42.6494 29.7005C42.2348 29.7066 41.8231 29.6325 41.4366 29.4824C41.0977 29.3479 40.8022 29.1228 40.5825 28.8317C40.3647 28.5304 40.247 28.1682 40.2461 27.7964H41.8433C41.8512 27.9955 41.9361 28.1837 42.08 28.3214C42.2263 28.4447 42.4138 28.5082 42.605 28.4989C42.792 28.5087 42.9769 28.4553 43.13 28.3473C43.187 28.2983 43.2334 28.2383 43.2664 28.1708C43.2995 28.1034 43.3185 28.0299 43.3223 27.9549C43.3261 27.8798 43.3146 27.8048 43.2886 27.7344C43.2625 27.6639 43.2224 27.5995 43.1707 27.545C43.0625 27.4419 42.9374 27.3581 42.8009 27.2973C42.5927 27.214 42.3805 27.1412 42.165 27.0791C41.8314 26.9825 41.5061 26.8589 41.1926 26.7094C40.9353 26.583 40.7121 26.3966 40.5419 26.1659C40.3505 25.8927 40.2555 25.5636 40.272 25.2305C40.2603 24.9728 40.3106 24.7161 40.4187 24.4819C40.5268 24.2478 40.6895 24.0429 40.8931 23.8847C41.3769 23.565 41.9439 23.3947 42.5236 23.3947C43.1034 23.3947 43.6704 23.565 44.1542 23.8847C44.3598 24.0456 44.5265 24.2508 44.6417 24.4851C44.757 24.7194 44.8178 24.9768 44.8197 25.2379H43.2187C43.2174 25.1483 43.1968 25.0601 43.1586 24.9791C43.1203 24.8981 43.0652 24.8263 42.9969 24.7683C42.8522 24.6506 42.6693 24.5901 42.483 24.5982C42.3235 24.59 42.1667 24.6414 42.043 24.7424C41.986 24.7954 41.9416 24.8604 41.9128 24.9326C41.884 25.0049 41.8717 25.0826 41.8766 25.1602C41.8759 25.2558 41.9018 25.3496 41.9514 25.4313C42.001 25.5129 42.0724 25.5791 42.1576 25.6224C42.4359 25.7762 42.7296 25.9001 43.0339 25.9921C43.3643 26.0946 43.6879 26.2181 44.0026 26.3619C44.2559 26.4879 44.4763 26.6715 44.6459 26.898C44.8369 27.1589 44.9334 27.4771 44.9195 27.8001C44.9241 28.1375 44.8303 28.469 44.6496 28.754C44.4622 29.0508 44.1941 29.288 43.8769 29.438C43.5035 29.6178 43.0933 29.7077 42.6789 29.7005H42.6494Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_1956_36410)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M183.231 23.3966H40.2773V29.7005H183.231V23.3966Z",
    fill: "url(#paint7_linear_1956_36410)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1956_36410",
    x1: 9.14455,
    y1: 19.5811,
    x2: 19.2478,
    y2: 34.6104,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#717171"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#717171"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#717171"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1956_36410",
    x1: 3.66267,
    y1: 24.8074,
    x2: 5.00912,
    y2: 25.1161,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#717171"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#717171"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#717171"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1956_36410",
    x1: 16.569,
    y1: -2.53275,
    x2: 19.4903,
    y2: -1.87685,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#717171"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#717171"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#717171"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1956_36410",
    x1: 11.3014,
    y1: -2.53275,
    x2: 14.2227,
    y2: -1.87685,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#717171"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#717171"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#717171"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1956_36410",
    x1: 9.16576,
    y1: -31.9642,
    x2: 39.4342,
    y2: -23.6424,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#717171"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#717171"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#717171"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1956_36410",
    x1: 12.3256,
    y1: -9.58543,
    x2: 24.4938,
    y2: -6.55645,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#717171"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#717171"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#717171"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1956_36410",
    x1: 85.7336,
    y1: -29.2716,
    x2: 133.862,
    y2: 44.5121,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#717171"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#717171"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#717171"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1956_36410",
    x1: 85.7813,
    y1: 14.5595,
    x2: 91.7846,
    y2: 45.1253,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#717171"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#717171"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#717171"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBranding7Logo);
export default __webpack_public_path__ + "static/media/branding-7-logo.8c6adbf592f59f642a0559c8d6ef3242.svg";
export { ForwardRef as ReactComponent };